module.exports = __webpack_public_path__ + "static/media/circle-with-exclamation.00098678.svg";